module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ1JREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LINBTj+D++oAbG8WhQj/CgptRikM8OkqNxwOJ41OJRi0ctBpVY+sSI0cLHE4AWxSNZOh9IBdArqGHFZAEQJ9ArjguQymIBIL4ACgW61E7QOD0AbVs5AMvrj3RLlSDLgZh/tKE+6AFAgAEAd88qW09LKCoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/6.png
// module id = 761
// module chunks = 0